<template>
    <div class="prose prose-sm">
        <div v-html="compiledMarkdown"></div>

        <!-- <vue-html2pdf
            :show-layout="false"
            :enable-download="true"
            :preview-modal="false"
            :filename="fileName"
            :pdf-quality="2"
            :manual-pagination="true"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="800px"
            ref="html2Pdf"

            @progress="onProgress($event)"
            @hasStartedDownload="hasStartedDownload()"
            @hasGenerated="hasGenerated()"
        >
            <section slot="pdf-content">
                <div class="prose prose-sm">
                    <div class="p-4" v-html="compiledMarkdown"></div>
                </div>
            </section>
        </vue-html2pdf> -->
    </div>
</template>
<script>
    import moment from 'moment';
    import { mapState } from "vuex";
    import DOMPurify from 'dompurify';
    import hljs from 'highlight.js';
    // import VueHtml2pdf from 'vue-html2pdf';
    import marked from 'marked';

    export default {
        name: 'NoteContent',
        components: {
            // VueHtml2pdf
        },
        data () {
            return {}
        },
        watch: {
            noteData: {
                deep: true,
                handler (newVal) {
                    if (newVal) {
                        this.$store.dispatch('updateNote', newVal);
                    }
                }
            }
        },
        computed: {
            fileName () {
                return 'Notie-' + moment().format('l');
            },
			compiledMarkdown () {
                if (this.noteData.content) {
                    marked.setOptions({
                        highlight: function(code, language) {
                            const validLanguage = hljs.getLanguage(language) ? language : 'plaintext';
                            return hljs.highlight(validLanguage, code).value;
                        }
                    });
                    var markedText = DOMPurify.sanitize(marked(this.noteData.content));
                    return markedText;
                } else {
                    return '';
                }
            },
            ...mapState(["noteData"])
        },
        mounted() {
            
        }
    };
</script>